import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { getUserPortfolioById } from '~/database/supabase/portfolio/queries.server.ts';
import type { ImportContext } from '~/views/portfolio/import/types.ts';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export interface PortfolioImportPageData {
	readonly context: ImportContext;
}

export const getPortfolioImportPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'supabase.portfolio.lookup'],
			relatesTo: 'portfolio.import-page',
		}),
	])
	.inputValidator((data: { portfolioId: number }) => data)
	.handler(async ({ data }: { data: { portfolioId: number } }): Promise<PortfolioImportPageData> => {
		const request = getRequest();
		const authSession = await requireStartAuthSession({ request });
		const portfolio = await getUserPortfolioById({
			portfolioId: data.portfolioId,
			userId: authSession.userId,
		});

		const requestUrl = new URL(request.url);

		return {
			context: {
				mode: 'existing-portfolio',
				portfolioCurrency: portfolio?.currency ?? requestUrl.searchParams.get('portfolioCurrency') ?? undefined,
				portfolioId: portfolio?.id ?? data.portfolioId,
				portfolioName: portfolio?.name ?? requestUrl.searchParams.get('portfolioName') ?? undefined,
			},
		};
	});
